interface CustomerContextInputProps {
  customerName: string;
  caseId: string;
  onCustomerNameChange: (value: string) => void;
  onCaseIdChange: (value: string) => void;
  disabled?: boolean;
}

export function CustomerContextInput({
  customerName,
  caseId,
  onCustomerNameChange,
  onCaseIdChange,
  disabled,
}: CustomerContextInputProps) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <div>
        <label htmlFor="customer-name" className="mb-1 block text-xs font-medium text-gray-500">
          Customer name (optional)
        </label>
        <input
          id="customer-name"
          type="text"
          value={customerName}
          onChange={(e) => onCustomerNameChange(e.target.value)}
          placeholder="e.g. ABC Corp"
          disabled={disabled}
          className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm focus:border-brand-accent focus:bg-white focus:outline-none focus:ring-1 focus:ring-brand-accent"
        />
      </div>
      <div>
        <label htmlFor="case-id" className="mb-1 block text-xs font-medium text-gray-500">
          Case ID (optional)
        </label>
        <input
          id="case-id"
          type="text"
          value={caseId}
          onChange={(e) => onCaseIdChange(e.target.value)}
          placeholder="e.g. SFLINK-3121"
          disabled={disabled}
          className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm focus:border-brand-accent focus:bg-white focus:outline-none focus:ring-1 focus:ring-brand-accent"
        />
      </div>
    </div>
  );
}
